export const App_Urls = {
  LOGIN: "api/Public/AuthenticateUser",
  VALIDATE_USER_LOGIN: "api/Public/ValidateUserLogin",
  FORGOT_PASSWORD: "api/Public/ForgotPassword",
  RESET_PASSWORD: "api/Public/ResetPassword",
  VALIDATE_OTP: "api/Public/ValidateOtp",
  GET_ROLE_PREV: ""
};
